import React, { useState } from 'react';
import '../styles/LawAppointment.css';
import axios from 'axios';

const morningSlots = [
  { slot: 'M1', label: 'Slot 1', time: '7:00 - 7:20 AM' },
  { slot: 'M2', label: 'Slot 2', time: '7:20 - 7:40 AM' },
  { slot: 'M3', label: 'Slot 3', time: '7:40 - 8:00 AM' },
  { slot: 'M4', label: 'Slot 4', time: '8:00 - 8:20 AM' },
  { slot: 'M5', label: 'Slot 5', time: '8:20 - 8:40 AM' },
  { slot: 'M6', label: 'Slot 6', time: '8:40 - 9:00 AM' },
];

const eveningSlots = [
  { slot: 'E1', label: 'Slot 1', time: '6:30 - 6:50 PM' },
  { slot: 'E2', label: 'Slot 2', time: '6:50 - 7:10 PM' },
  { slot: 'E3', label: 'Slot 3', time: '7:10 - 7:30 PM' },
  { slot: 'E4', label: 'Slot 4', time: '7:30 - 7:50 PM' },
  { slot: 'E5', label: 'Slot 5', time: '7:50 - 8:10 PM' },
  { slot: 'E6', label: 'Slot 6', time: '8:10 - 8:30 PM' },
];

const ResearchAppointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    university: '',
    email: '',
    mobile: '',
    researchField: '',
    supervisor: '',
    mode: '',
    appointmentDate: '',
    selectedSlot: '',
  });

  const [disabledSlots, setDisabledSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSlotSelect = (slotId) => {
    if (!disabledSlots.includes(slotId)) {
      setFormData({ ...formData, selectedSlot: slotId });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.selectedSlot) {
      alert('Please select a time slot.');
      return;
    }
    setLoading(true);

    try {
      const orderId = 'RESEARCH-' + Date.now();
      const res = await axios.post('/api/payment/create-session', {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        orderId,
        type: 'research',
        appointmentData: formData,
      });
      const { payment_links } = res.data;
      if (payment_links?.web) {
        setDisabledSlots((prev) => [...prev, formData.selectedSlot]);
        window.location.href = payment_links.web;
      } else {
        alert('Payment failed: No payment link received');
      }
    } catch (err) {
      console.error('Payment error:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="law-appointment-wrapper">
      <div className="law-content three-column-layout">
        {/* Left: Terms & Conditions */}
        <div className="law-terms-box">
          <h3>📌 Terms and Conditions</h3>
          <ul>
            <li>Once the payment is completed, <strong style={{ color: 'red' }}><u>the amount will not be refunded</u></strong>.</li>
            <li>Ensure all details entered are <strong>accurate</strong> before proceeding.</li>
            <li>Appointment slots are confirmed only after successful payment.</li>
            <li>Slot changes allowed only in <strong>exceptional cases</strong>.</li>
            <li>Contact support within <strong>24 hours</strong> for technical issues.</li>
          </ul>
        </div>

        {/* Center: Form */}
        <div className="law-form-card">
          <form onSubmit={handleSubmit}>
            <input name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
            <input name="university" placeholder="University/Institute" value={formData.university} onChange={handleChange} required />
            <input name="email" type="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
            <input name="mobile" type="tel" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />
            <input name="researchField" placeholder="Field of Research (e.g. AI, BioTech)" value={formData.researchField} onChange={handleChange} required />
            <input name="appointmentDate" type="date" value={formData.appointmentDate} onChange={handleChange} required />

            <select name="supervisor" value={formData.supervisor} onChange={handleChange} required>
              <option value="">-- Select Supervising Team --</option>
              <option value="team1">Team 1</option>
              <option value="team2">Team 2</option>
            </select>

            <select name="mode" value={formData.mode} onChange={handleChange} required>
              <option value="">-- Select Mode --</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>

            {/* Time Slots */}
            <div className="time-slot-section">
              <div className="slots-group">
                <h4>Morning Slots</h4>
                <div className="slots">
                  {morningSlots.map(({ slot, label, time }) => (
                    <button key={slot} type="button" className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`} onClick={() => handleSlotSelect(slot)} disabled={disabledSlots.includes(slot)} title={time}>{label}</button>
                  ))}
                </div>
              </div>
              <div className="slots-group">
                <h4>Evening Slots</h4>
                <div className="slots">
                  {eveningSlots.map(({ slot, label, time }) => (
                    <button key={slot} type="button" className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`} onClick={() => handleSlotSelect(slot)} disabled={disabledSlots.includes(slot)} title={time}>{label}</button>
                  ))}
                </div>
              </div>
            </div>

            <p style={{ fontWeight: 'bold', marginTop: '10px', textAlign: 'center' }}>Appointment Fee ₹100</p>
            <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Book Appointment'}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResearchAppointment;
